/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseEmbedPanelFragment, EmbedPanelFragment, FullEmbedPanelFragment} from '@amblique/contentful/app/contentful/fragments/embed-panel';

/**
 * Get a single EmbedPanel by ID (base - scalars only)
 */
export const getBaseEmbedPanelById = gql`
  ${BaseEmbedPanelFragment}

  query GetBaseEmbedPanelById($id: String!, $locale: String!, $preview: Boolean) {
    embedPanel(id: $id, locale: $locale, preview: $preview) {
      ...BaseEmbedPanelFragment
    }
  }
`;

/**
 * Get a single EmbedPanel by ID (standard - 1 level deep)
 */
export const getEmbedPanelById = gql`
  ${EmbedPanelFragment}

  query GetEmbedPanelById($id: String!, $locale: String!, $preview: Boolean) {
    embedPanel(id: $id, locale: $locale, preview: $preview) {
      ...EmbedPanelFragment
    }
  }
`;

/**
 * Get a single EmbedPanel by ID (full - 2 levels deep)
 */
export const getFullEmbedPanelById = gql`
  ${FullEmbedPanelFragment}

  query GetFullEmbedPanelById($id: String!, $locale: String!, $preview: Boolean) {
    embedPanel(id: $id, locale: $locale, preview: $preview) {
      ...FullEmbedPanelFragment
    }
  }
`;

/**
 * Get all EmbedPanel entries with pagination (base - scalars only)
 */
export const getBaseEmbedPanels = gql`
  ${BaseEmbedPanelFragment}

  query GetBaseEmbedPanels(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [EmbedPanelOrder]
    $where: EmbedPanelFilter
    $preview: Boolean
  ) {
    embedPanelCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseEmbedPanelFragment
      }
    }
  }
`;

/**
 * Get all EmbedPanel entries with pagination (standard - 1 level deep)
 */
export const getEmbedPanels = gql`
  ${EmbedPanelFragment}

  query GetEmbedPanels(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [EmbedPanelOrder]
    $where: EmbedPanelFilter
    $preview: Boolean
  ) {
    embedPanelCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...EmbedPanelFragment
      }
    }
  }
`;

/**
 * Get all EmbedPanel entries with pagination (full - 2 levels deep)
 */
export const getFullEmbedPanels = gql`
  ${FullEmbedPanelFragment}

  query GetFullEmbedPanels(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [EmbedPanelOrder]
    $where: EmbedPanelFilter
    $preview: Boolean
  ) {
    embedPanelCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullEmbedPanelFragment
      }
    }
  }
`;
